import axiosServerGolang from '@/configs/axiosServerGolang'
import axiosServer from '@/configs/axiosServer'

export default {
  async validateActivity ({ Authorization, data }) {
    const url = 'program-activity/v3/program-detail/validate'
    try {
      const result = await axiosServerGolang({
        method: 'POST',
        url,
        headers: {
          Authorization
        },
        data
      })
      return result
    } catch (error) {
      console.error(error, 'Failed to validate activity')
    }
  },
  async validateProgram ({ Authorization, data }) {
    // PLEASE REFER TO REPO WEBSITE-NEW-LMS-KARIERMU TO VALIDATE IF THIS API IS STILL IN USE
    try {
      const result = await axiosServerGolang({
        method: 'POST',
        url: '/program-activity/v3/program-detail/validate',
        headers: { Authorization },
        data
      })
      return result
    } catch (error) {
      return error
    }
  },
  async getActivityDashboard ({ Authorization, data }) {
    const url = 'program-activity/v3/program-detail/get/activity-dashboard'
    try {
      const result = await axiosServerGolang({
        method: 'POST',
        url,
        headers: {
          Authorization
        },
        data
      })
      return result
    } catch (error) {
      console.error(error, 'Failed to get activity dashboard')
    }
  },
  async getTabAnnouncement ({ Authorization, data }) {
    const url = 'program-activity/v3/program-detail/get/tab-announcement'
    try {
      const result = await axiosServerGolang({
        method: 'POST',
        url,
        headers: {
          Authorization
        },
        data
      })
      return result
    } catch (error) {
      console.error(error, 'Failed to get tab announcement')
    }
  },
  async getReport ({ Authorization, data }) {
    const url = 'program-activity/v3/program-detail/get/report'
    try {
      const result = await axiosServerGolang({
        method: 'POST',
        url,
        headers: {
          Authorization
        },
        data
      })
      return result
    } catch (error) {
      console.error(error, 'Failed to get report')
    }
  },
  async getProgressReport ({ Authorization, data }) {
    const url = 'program-activity/prakerja-user-progress'
    try {
      const result = await axiosServerGolang({
        method: 'POST',
        url,
        headers: {
          Authorization
        },
        data
      })
      return result
    } catch (error) {
      console.error(error, 'Failed to get progress report')
    }
  },
  async getProgramRecommendation ({ Authorization, program_slug }) {
    const url = `program_activity/program_recommendation/${program_slug}/`
    try {
      const result = await axiosServer({
        method: 'GET',
        url,
        headers: {
          Authorization
        }
      })
      return result
    } catch (error) {
      console.error(error, 'Failed to get program_recommendation')
    }
  },
  async recalculate ({ Authorization, data }) {
    const url = 'program_activity/score/'
    try {
      const result = await axiosServer({
        method: 'POST',
        url,
        headers: {
          Authorization
        },
        data
      })
      return result
    } catch (error) {
      console.error(error, 'Failed to get report')
    }
  },
  async getTabActivityItems ({ Authorization, data }) {
    const url = 'program-activity/v3/program-detail/get/tab-activity'
    try {
      const result = await axiosServerGolang({
        method: 'POST',
        url,
        headers: {
          Authorization
        },
        data
      })
      return result
    } catch (error) {
      console.error(error, 'Failed to get data for tab activity')
    }
  },
  async getChapterDetail ({ Authorization, data }) {
    const url = 'program-activity/v3/chapter-detail/get'
    try {
      const result = await axiosServerGolang({
        method: 'POST',
        url,
        headers: {
          Authorization
        },
        data
      })
      return result
    } catch (error) {
      console.error(error, 'Failed to get data activities for desired chapter')
    }
  },
  async getActivityDetail ({ Authorization, data }) {
    const url = 'program-activity/v4/activity-detail/get'
    try {
      const result = await axiosServerGolang({
        method: 'POST',
        url,
        headers: {
          Authorization
        },
        data
      })
      return result
    } catch (error) {
      console.error(error, 'Failed to get activity detail data')
    }
  },
  async getActivityGroupDetail ({ Authorization, data }, page = 1, perPage = 12) {
    const url = `program-activity/v4/activity-detail/group/get?page=${page}&items_per_page=${perPage}`
    try {
      const result = await axiosServerGolang({
        method: 'POST',
        url,
        headers: {
          Authorization
        },
        data
      })
      return result
    } catch (error) {
      console.error(error, 'Failed to get activity group detail data')
    }
  },
  async resetRejectedActivityByPmo ({ Authorization, data }) {
    const url = 'program-activity/activity/pmo/reset'
    try {
      const result = await axiosServerGolang({
        method: 'POST',
        url,
        headers: {
          Authorization
        },
        data
      })
      return result
    } catch (error) {
      console.error(error, 'Failed to reset rejected activity by PMO')
    }
  },
  async getActivityFacilFeedback ({ Authorization, activityId }) {
    const url = `program_activity/product_activity/view_feedback/${activityId}`
    try {
      const result = await axiosServer({
        method: 'GET',
        url,
        headers: {
          Authorization
        }
      })
      return result
    } catch (error) {
      console.error(error, 'Failed to get facil feedback data')
    }
  },
  async getParentComment ({ Authorization, activity_id, page, per_page }) {
    const url = `program_activity/resource/user_comment/${activity_id}/${page}/${per_page}`
    try {
      const result = await axiosServer({
        method: 'GET',
        url,
        headers: {
          Authorization
        }
      })
      return result
    } catch (error) {
      console.error(error, 'Failed to get parent comment')
    }
  },
  async getChildComment ({
    Authorization,
    activity_id,
    page,
    per_page,
    parent_id
  }) {
    const url = `program_activity/resource/reply_comment/${activity_id}/${parent_id}/${page}/${per_page}`
    try {
      const result = await axiosServer({
        method: 'GET',
        url,
        headers: {
          Authorization
        }
      })
      return result
    } catch (error) {
      console.error(error, 'Failed to get child comment')
    }
  },
  async submitComment ({ Authorization, data }) {
    const url = 'program_activity/resource/comment/'
    try {
      const result = await axiosServer({
        method: 'POST',
        url,
        headers: {
          Authorization
        },
        data
      })
      return result
    } catch (error) {
      console.error(error, 'Failed to submit comment')
    }
  },
  async setActivityComplete ({ Authorization, data }) {
    const url = 'program_activity/activity/'
    try {
      const result = await axiosServer({
        method: 'POST',
        url,
        headers: {
          Authorization
        },
        data,
        generateQueryParamSource: true
      })
      return result
    } catch (error) {
      console.error(error, 'Failed to set activity complete')
    }
  },
  async sendReview ({ Authorization, payload }) {
    try {
      const { data } = await axiosServer({
        url: '/program_activity/rating/',
        method: 'post',
        headers: { Authorization },
        data: payload
      })
      return data
    } catch (error) {
      return error
    }
  },
  async getPersonalTanyamuRoom ({ Authorization, data }) {
    const url = '/program_activity/personal_chat/'
    try {
      const result = await axiosServer({
        method: 'POST',
        url,
        headers: {
          Authorization
        },
        data
      })
      return result
    } catch (error) {
      console.error(error, 'Failed to get tanyamu room id')
    }
  },
  async getProgramGroupActivity ({ Authorization, data }) {
    const url = `/program-activity/study-group/me/${data.page}/${data.itemsPerPage}`
    try {
      const result = await axiosServerGolang({
        method: 'POST',
        url,
        headers: {
          Authorization
        },
        data: {
          program_id: data.programId
        }
      })
      return result
    } catch (error) {
      console.error(error, 'Failed to get Program Group Activity')
    }
  },
  async validateRedeemCodePrakerja ({ Authorization, data }) {
    const url = '/program-activity/prakerja/redeem-code'
    try {
      const result = await axiosServerGolang({
        method: 'POST',
        url,
        headers: {
          Authorization
        },
        data: {
          program_id: data.program_id,
          redemption_code: data.redemption_code
        }
      })
      return result
    } catch (error) {
      console.error(error, 'Failed to validate Redemption Code')
      return {
        data: {
          status: 503,
          message: 'Gagal memvalidasi kode redeem'
        }
      }
    }
  },
  async submitVerifyRedeemCodePrakerja ({ Authorization, data }) {
    const url = '/prakerja/redeem/submit-verify'
    try {
      const result = await axiosServerGolang({
        method: 'POST',
        url,
        headers: {
          Authorization
        },
        data: {
          program_id: data.program_id,
          redemption_code: data.redemption_code
        }
      })
      return result
    } catch (error) {
      console.error(error, 'Failed to validate Redemption Code')
      return {
        data: {
          status: 503,
          message: 'Gagal memvalidasi kode redeem'
        }
      }
    }
  },
  async checkUpdatePrakerja ({ Authorization, payload }) {
    const url = '/prakerja/redeem/check-update'
    try {
      const result = await axiosServerGolang({
        method: 'POST',
        url,
        headers: {
          Authorization
        },
        data: {
          state_redemption_code: payload.state_redemption_code,
          error_code: payload.error_code,
          error: payload.error,
          error_description: payload.error_description
        }
      })
      return result
    } catch (error) {
      console.error(error, 'Failed to check update prakerja')
    }
  },
  async checkAttemptFrSequence ({ Authorization, payload }) {
    const url = '/prakerja/attempt-fr-sequence'
    try {
      const result = await axiosServerGolang({
        method: 'POST',
        url,
        headers: {
          Authorization
        },
        data: {
          sequence: payload.sequence,
          program_id: payload.programId
        }
      })
      return result
    } catch (error) {
      console.error(error, 'Failed to check attempt fr sequence')
    }
  },
  async saveSelectedGroupActivity ({ Authorization, data }) {
    const url = 'program/resource_group/select_group/?refresh=1' // Need refresh query to trigger update elastic almost instantly
    try {
      const result = await axiosServer({
        method: 'POST',
        url,
        headers: {
          Authorization
        },
        data
      })
      return result
    } catch (error) {
      console.error(error, 'Failed to save selected group activity')
    }
  },
  async getStudyGroup ({ Authorization, programId, name, status }) {
    const url = `program-activity/study-group/manual-by-user/${programId}?name=${name}&status=${status}`
    try {
      const result = await axiosServerGolang({
        method: 'GET',
        url,
        headers: {
          Authorization
        }
      })
      return result
    } catch (error) {
      console.error(error, 'Failed to get study group')
    }
  },
  async getSessionCompletion ({ Authorization, programId, session }) {
    const url = `/program-activity/session-completion/${programId}/${session}`
    try {
      const result = await axiosServerGolang({
        method: 'GET',
        url,
        headers: {
          Authorization
        }
      })
      return result
    } catch (error) {
      console.error(error, 'Failed to get session completion')
    }
  },
  async getZoomSignature ({ meetingNumber, role }) {
    const url = '/program-activity/zoom/signature'
    try {
      const result = await axiosServerGolang({
        method: 'POST',
        url,
        headers: {
          Authorization: process.env.VUE_APP_APP_KEY
        },
        data: {
          meeting_number: meetingNumber,
          role
        }
      })
      return result
    } catch (error) {
      console.error(error, 'Failed to get last activity list')
    }
  },
  async setCompletedStreakLiveProgram ({ Authorization, resource_id }) {
    const url = 'program-activity/open-activity-tab'
    try {
      const result = await axiosServerGolang({
        method: 'POST',
        url,
        headers: {
          Authorization
        },
        data: {
          resource_id
        }
      })
      return result
    } catch (error) {
      console.error(error, 'Failed to set completed streak live program')
    }
  }
}
